import axios from 'axios';
import authHeader from './auth-header';
import publicHeader from './public-header';

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/Feature/notification`;

class NotificationService {
  sendEmail(emailModel) {
    return axios.post(`${API_URL}/SendEmail`,
    emailModel,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response.data;
    });
  }

  resendEmail(){
    return axios.patch(`${API_URL}/ResendEmail`,
    {
      headers: publicHeader() 
    })
    .then(response => {
      return response.data;
    });
  }

  getEmailTemplate(loanNumber, notificationType){
    return axios.get(`${API_URL}/EmailTemplate?loanNumber=${loanNumber}&notificationType=${notificationType}`,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response.data;
    });
  }
}

export default new NotificationService();